"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegList = getRegList;
exports.is65emallCnDomain = exports.isEzbuyDevDomain = exports.is65emallNetDomain = exports.isLocalOrUatDevelop = exports.isUatDevelop = exports.UAT_DOMAIN = exports.isLocalDevelop = exports.LOCAL_DOMAIN = exports.LOCAL_DOMAIN_REGEXP = exports.getSunflowerInfoFromHost = exports.getBlazerInfoFromHost = exports.getEzbuyInfoFromHost = exports.litbDomains = exports.sunflowerDomains = exports.blazerDomains = exports.ezbuyDomains = void 0;

var _types = require("./types");

var _regex = require("./regex");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _wrapRegExp(re, groups) { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _RegExp = _wrapNativeSuper(RegExp); var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = _RegExp.call(this, re, flags); _groups.set(_this, groups || _groups.get(re)); return _this; } _inherits(BabelRegExp, _RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = []; args.push.apply(args, arguments); if (_typeof(args[args.length - 1]) !== "object") { args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ezbuyDomains = {
  pcUatDomains: [/*#__PURE__*/_wrapRegExp(/^(kdev|ktest)([0-9]*)\x2D([A-Za-z]{2,3}).ezbuy\.dev$/, {
    env: 2,
    catalog: 3
  }), /*#__PURE__*/_wrapRegExp(/^([A-Za-z]{2,3})\.(kdev|ktest)([0-9]*)\.65emall\.net$/, {
    catalog: 1,
    env: 3
  }), /*#__PURE__*/_wrapRegExp(/^([A-Za-z]{2,3})\x2D(kdev|ktest)([0-9]*)\.ezbuy\.dev$/, {
    catalog: 1,
    env: 3
  }), /*#__PURE__*/_wrapRegExp(/^((kdev|ktest)([0-9]*)\x2D[A-Za-z]{2,3})\.ezbuy\.dev$/, {
    catalog: 1,
    env: 3
  })],
  pcOnlineDomains: [/*#__PURE__*/_wrapRegExp(/^ezbuy\.(co\.)?([A-Za-z]{2})$/, {
    catalog: 2
  }), /*#__PURE__*/_wrapRegExp(/^([A-Za-z]{2})\.ezbuy\.com$/, {
    catalog: 1
  })],
  mUatDomains: [/*#__PURE__*/_wrapRegExp(/^m.*\.([A-Za-z]{2})\.(kdev|ktest)([0-9]*)\.65emall\.net$/, {
    catalog: 1,
    env: 3
  }), /*#__PURE__*/_wrapRegExp(/^m\x2D([A-Za-z]{2})\x2D(kdev|ktest)([0-9]*)\.ezbuy\.dev$/, {
    catalog: 1,
    env: 3
  })],
  mOnlineDomains: [/*#__PURE__*/_wrapRegExp(/^m\.ezbuy\.(co\.)?([A-Za-z]{2})$/, {
    catalog: 2
  }), /*#__PURE__*/_wrapRegExp(/^m\x2D([A-Za-z]{2})\.ezbuy\.com$/, {
    catalog: 1
  })]
};
exports.ezbuyDomains = ezbuyDomains;
var blazerDomains = {
  pcUatDomains: [/*#__PURE__*/_wrapRegExp(/^web([0-9]*)\.ezbuy\.dev$/, {
    env: 1
  })],
  pcOnlineDomains: [/^(www\.)?ezbuy\.com$/],
  mUatDomains: [/*#__PURE__*/_wrapRegExp(/^m([0-9]*)\.ezbuy\.dev$/, {
    env: 1
  })],
  mOnlineDomains: [/^m\.ezbuy\.com$/]
};
exports.blazerDomains = blazerDomains;
var sunflowerDomains = {
  pcUatDomains: [/*#__PURE__*/_wrapRegExp(/^(dev\.)?kdev([0-9]*)\.([A-Za-z]+)\.(65emall\.net|ezbuy\.dev)$/, {
    env: 2,
    site: 3
  }), /*#__PURE__*/_wrapRegExp(/^(dev\x2D)?kdev([0-9]*)\x2D([A-Za-z]+)\.(65emall\.net|ezbuy\.dev)$/, {
    env: 2,
    site: 3
  }), /*#__PURE__*/_wrapRegExp(/^(kdev|ktest)([0-9]*)\.([A-Za-z]+)\.sunflower\x2Dmobileweb\.65emall\.net$/, {
    env: 2,
    site: 3
  })],
  pcOnlineDomains: [/*#__PURE__*/_wrapRegExp(/^(www\.)?([A-Za-z]+)\.com$/, {
    site: 2
  })],
  mUatDomains: [/*#__PURE__*/_wrapRegExp(/^m(dev)?\.kdev([0-9]*)\.([A-Za-z]+)\.(65emall\.net|ezbuy\.dev)$/, {
    env: 2,
    site: 3
  }), /*#__PURE__*/_wrapRegExp(/^m(dev)?\x2Dkdev([0-9]*)\x2D([A-Za-z]+)\.(65emall\.net|ezbuy\.dev)$/, {
    env: 2,
    site: 3
  }), /*#__PURE__*/_wrapRegExp(/^(kdev|ktest)([0-9]*)\.([A-Za-z]+)\.sunflower\x2Dmobileweb\.65emall\.net$/, {
    env: 2,
    site: 3
  })],
  mOnlineDomains: [/*#__PURE__*/_wrapRegExp(/^(m\.|www\.)?([A-Za-z]+)\.com$/, {
    site: 2
  })]
};
exports.sunflowerDomains = sunflowerDomains;
var litbDomains = {
  pcUatDomains: [/lightinthebox.com$/]
};
exports.litbDomains = litbDomains;

function transformTW() {
  var catalog = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return catalog.replace(/^tw$/i, "twc");
}

function getRegList(siteList) {
  return siteList.reduce(function (pValue, _ref) {
    var _ref$pcUatDomains = _ref.pcUatDomains,
        pcUatDomains = _ref$pcUatDomains === void 0 ? [] : _ref$pcUatDomains,
        _ref$pcOnlineDomains = _ref.pcOnlineDomains,
        pcOnlineDomains = _ref$pcOnlineDomains === void 0 ? [] : _ref$pcOnlineDomains,
        _ref$mUatDomains = _ref.mUatDomains,
        mUatDomains = _ref$mUatDomains === void 0 ? [] : _ref$mUatDomains,
        _ref$mOnlineDomains = _ref.mOnlineDomains,
        mOnlineDomains = _ref$mOnlineDomains === void 0 ? [] : _ref$mOnlineDomains;
    return [].concat(_toConsumableArray(pValue), _toConsumableArray(pcUatDomains.map(function (regex) {
      return {
        regex: regex,
        isuat: true,
        platform: _types.Platform.WEB
      };
    })), _toConsumableArray(pcOnlineDomains.map(function (regex) {
      return {
        regex: regex,
        isuat: false,
        platform: _types.Platform.WEB
      };
    })), _toConsumableArray(mUatDomains.map(function (regex) {
      return {
        regex: regex,
        isuat: true,
        platform: _types.Platform.MWEB
      };
    })), _toConsumableArray(mOnlineDomains.map(function (regex) {
      return {
        regex: regex,
        isuat: false,
        platform: _types.Platform.MWEB
      };
    })));
  }, []);
}

function getInfoFromHost(info) {
  var regList = getRegList([info]);
  /** 解析hostname获取站点信息 */

  return function (hostname) {
    var params = {};
    var regItem = regList.find(function (_ref2) {
      var regex = _ref2.regex;
      return regex.test(hostname);
    });

    if (regItem) {
      var _result$groups, _result$groups$catalo, _result$groups2, _result$groups3;

      var result = regItem.regex.exec(hostname);
      params.catalog = transformTW((_result$groups = result.groups) === null || _result$groups === void 0 ? void 0 : (_result$groups$catalo = _result$groups.catalog) === null || _result$groups$catalo === void 0 ? void 0 : _result$groups$catalo.toLowerCase());
      params.env = Number((_result$groups2 = result.groups) === null || _result$groups2 === void 0 ? void 0 : _result$groups2.env) || 0;
      params.site = ((_result$groups3 = result.groups) === null || _result$groups3 === void 0 ? void 0 : _result$groups3.site) || "";
      params.platform = regItem.platform;
      params.isuat = regItem.isuat;
    }

    return params;
  };
}

var getEzbuyInfoFromHost = getInfoFromHost(ezbuyDomains);
exports.getEzbuyInfoFromHost = getEzbuyInfoFromHost;
var getBlazerInfoFromHost = getInfoFromHost(blazerDomains);
exports.getBlazerInfoFromHost = getBlazerInfoFromHost;
var getSunflowerInfoFromHost = getInfoFromHost(sunflowerDomains);
exports.getSunflowerInfoFromHost = getSunflowerInfoFromHost;
var LOCAL_DOMAIN_REGEXP = /(?:192.168)|(?:localhost)|(?:127.0)|\:\:1|(0.0.0.0)/; // 本地域名判断

exports.LOCAL_DOMAIN_REGEXP = LOCAL_DOMAIN_REGEXP;
var LOCAL_DOMAIN = [/(?:192.168)/, /(?:localhost)/, /(?:127.0)/, /\:\:1/, /(0.0.0.0)/];
exports.LOCAL_DOMAIN = LOCAL_DOMAIN;

var isLocalDevelop = function isLocalDevelop(hostname) {
  return LOCAL_DOMAIN.some(function (domain) {
    return domain.test(hostname);
  });
}; // UAT域名判断


exports.isLocalDevelop = isLocalDevelop;
var UAT_DOMAIN = [_regex.emallNetDomainRegExp, _regex.ezbuyDevDomainRegExp, _regex.emallCnDomainRegExp, _regex.tboxMeDomainRegExp, _regex.litbDev0RegExp];
exports.UAT_DOMAIN = UAT_DOMAIN;

var isUatDevelop = function isUatDevelop(hostname) {
  return UAT_DOMAIN.some(function (domain) {
    return domain.test(hostname);
  });
}; // 本地、UAT域名判断


exports.isUatDevelop = isUatDevelop;

var isLocalOrUatDevelop = function isLocalOrUatDevelop(hostname) {
  return [].concat(LOCAL_DOMAIN, UAT_DOMAIN).some(function (domain) {
    return domain.test(hostname);
  });
}; // 65emall.net判断域名判断


exports.isLocalOrUatDevelop = isLocalOrUatDevelop;

var is65emallNetDomain = function is65emallNetDomain(hostname) {
  return _regex.emallNetDomainRegExp.test(hostname);
}; // ezbuy.dev域名判断


exports.is65emallNetDomain = is65emallNetDomain;

var isEzbuyDevDomain = function isEzbuyDevDomain(hostname) {
  return _regex.ezbuyDevDomainRegExp.test(hostname);
}; // 65emall.cn判断域名判断


exports.isEzbuyDevDomain = isEzbuyDevDomain;

var is65emallCnDomain = function is65emallCnDomain(hostname) {
  return _regex.emallCnDomainRegExp.test(hostname);
};

exports.is65emallCnDomain = is65emallCnDomain;